export default __webpack_public_path__ + "4fbe146c9a543e082859df602fd1c2e9.png";